import { useQuery } from 'react-query'

import AuthDataService from 'src/services/auth.service'

import { QUERY_KEYS, STORAGE_KEYS } from 'src/constants'

const useUser = () => {
  return useQuery(
    [QUERY_KEYS.AUTH_USER],
    () => {
      if (!localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN)) return null

      return AuthDataService.checkIsAuthenticated()
    },
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  )
}

export { useUser }
